import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const TissueShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Tissue Section"
    sectionKey="Tissue"
    backRoute="/sections/tissue"
  />
);

export default TissueShipmentRequest;
